import { render, staticRenderFns } from "./corporateLogo.vue?vue&type=template&id=3d0dd1a1&"
import script from "./corporateLogo.vue?vue&type=script&lang=js&"
export * from "./corporateLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports